import { render, staticRenderFns } from "./treemap.vue?vue&type=template&id=400ded46"
import script from "./treemap.vue?vue&type=script&lang=js"
export * from "./treemap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports